export const USER_DIALOGUE_TYPE = {
    COUPON_REMOVE_BENEFIT_CONFIRMATION: 'COUPON_REMOVE_BENEFIT_CONFIRMATION',
    VAS_REMOVE_COUPON_WARNING: 'VAS_REMOVE_COUPON_WARNING',
    INSURANCE_REPLACE_COUPON_WARNING: 'INSURANCE_REPLACE_COUPON_WARNING'
} as const

export const INSURANCE_REPLACE_COUPON_INFO_ICON =
    'https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/itinerary/info-icon.png'

export const COUPON_SUCCESS_OFFER_ICON =
    'https://static-assets-ct.flixcart.com/ct/assets/offermgmt/images/common/OffersApplied.svg'

export const COUPON_ALERT_ICON =
    'https://static-assets-ct.flixcart.com/ct/assets/offermgmt/images/common/Alert.svg'

export const USER_DIALOGUE_ACTION_TYPE = {
    DISMISS: 'DISMISS'
} as const

export const REMOVE_POPUP_TYPES = [
    USER_DIALOGUE_TYPE.COUPON_REMOVE_BENEFIT_CONFIRMATION,
    USER_DIALOGUE_TYPE.VAS_REMOVE_COUPON_WARNING
] as const
